export const FORM_KEY = 'glane';
export const NETWORK_NAME = 'le Réseau Santé de la Glâne';
export const DISTRICT_NAME = 'la Glâne';
export const LANG = 'fr';
export const YES = 'Oui';
export const NO = 'Non';
export const NURSING_HOME_LOCATION_ID = '137566';

export const ADMIN_REP_TITLES = [
  {
    'id': '137519',
    'label': 'Madame'
  },
  {
    'id': '137520',
    'label': 'Monsieur'
  }
];
export const ADMIN_REP_OFFICIAL_MEASURES = [
  {
    'id': '137521',
    'label': 'Aucune curatelle'
  },
  {
    'id': '137522',
    'label': 'Candidat sous curatelle'
  },
  {
    'id': '137523',
    'label': 'Demande de curatelle en cours'
  }
];
export const BENEFITS_SERVICES = [
  {
    'id': '137535',
    'label': 'PC Domicile'
  },
  {
    'id': '137536',
    'label': 'PC Home'
  }
];

export const CANDIDATE_TITLES = [
  {
    id: 137563,
    label: 'Madame'
  },
  {
    id: 137564,
    label: 'Monsieur'
  }
];

export const CANDIDATE_STATES = [
  {
    'id': '137468',
    'label': 'Argovie - Aargau'
  },
  {
    'id': '137469',
    'label': 'Appenzell Rhodes intérieures - Inner-Rhoden'
  },
  {
    'id': '137471',
    'label': 'Appenzell Rhodes extérieures - Ausser-Rhoden'
  },
  {
    'id': '137470',
    'label': 'Berne - Bern'
  },
  {
    'id': '137472',
    'label': 'Bâle Campagne - Basel Land'
  },
  {
    'id': '137475',
    'label': 'Bâle Ville - Basel Stadt'
  },
  {
    'id': '137473',
    'label': 'Genève - Genf'
  },
  {
    'id': '137474',
    'label': 'Fribourg - Freiburg'
  },
  {
    'id': '137476',
    'label': 'Glaris - Glarus'
  },
  {
    'id': '137477',
    'label': 'Jura'
  },
  {
    'id': '137478',
    'label': 'Lucerne -Luzern'
  },
  {
    'id': '137479',
    'label': 'Neuchâtel - Neuenburg'
  },
  {
    'id': '137480',
    'label': 'Grisons - Graubuenden'
  },
  {
    'id': '137481',
    'label': 'Nidwald - Nidwalden'
  },
  {
    'id': '137482',
    'label': 'Obwald - Obwalden'
  },
  {
    'id': '137483',
    'label': 'Saint-Gall - Sankt Gallen'
  },
  {
    'id': '137484',
    'label': 'Schaffhouse - Schaffausen'
  },
  {
    'id': '137485',
    'label': 'Soleure - Solothurn'
  },
  {
    'id': '137486',
    'label': 'Thurgovie - Thurgau'
  },
  {
    'id': '137487',
    'label': 'Schwyz'
  },
  {
    'id': '137488',
    'label': 'Ticino - Tessin'
  },
  {
    'id': '137489',
    'label': 'Uri'
  },
  {
    'id': '137490',
    'label': 'Vaud - Waadt'
  },
  {
    'id': '137491',
    'label': 'Valais - Vallis'
  },
  {
    'id': '137492',
    'label': 'Zug'
  },
  {
    'id': '137493',
    'label': 'Zurich - Zürich'
  }
];

export const CANDIDATE_STATUS = [
  {
    'id': '137503',
    'label': 'Célibataire'
  },
  {
    'id': '137504',
    'label': 'Marié(e)'
  },
  {
    'id': '137507',
    'label': 'Divorcé(e)'
  },
  {
    'id': '137505',
    'label': 'Veuf(ve)'
  },
  {
    'id': '137506',
    'label': 'Séparé(e)'
  }
];


export const COMPLEMENTARY_INSURANCE_TYPES = [
  {
    'id': '137526',
    'label': 'Privé'
  },
  {
    'id': '137528',
    'label': 'Autre'
  },
  {
    'id': '137527',
    'label': 'Demi-privé'
  }
];


export const RELATIVE1_TITLES = [
  {
    'id': '137515',
    'label': 'Madame'
  },
  {
    'id': '137516',
    'label': 'Monsieur'
  }
];

export const RELATIVE2_TITLES = [
  {
    'id': '137513',
    'label': 'Madame'
  },
  {
    'id': '137514',
    'label': 'Monsieur'
  }
];


export const SITUATION_LOCATIONS = [
  {
    'id': '137567',
    'label': 'Domicile'
  },
  {
    'id': '137568',
    'label': 'Hôpital'
  },
  {
    'id': '137565',
    'label': 'SEO'
  },
  {
    'id': '137566',
    'label': 'EMS'
  }
];
export const SITUATION_LIVES_WITH = [
  {
    'id': '137508',
    'label': 'Seul(e)'
  },
  {
    'id': '137509',
    'label': 'Avec conjoint'
  },
  {
    'id': '137510',
    'label': 'Avec enfant(s)'
  },
  {
    'id': '137511',
    'label': 'Animaux de compagnie'
  },
  {
    'id': '137512',
    'label': 'Autre'
  }
];

export const STAY_REQUEST_TYPES = [
  {
    'id': '137557',
    'label': 'Court séjour'
  },
  {
    'id': '137556',
    'label': 'Long séjour'
  },
  {
    'id': '137558',
    'label': 'Foyer de jour'
  },
  {
    'id': '137559',
    'label': 'Unité spécialisée en démence'
  },
  {
    'id': '137560',
    'label': `SEO (séjour d'évaluation et d'orientation) Billens`
  },
];
export const STAY_REQUEST_ENTRIES = [
  {
    'id': '137552',
    'label': 'immédiate'
  },
  {
    'id': '137553',
    'label': '1 mois'
  },
  {
    'id': '137554',
    'label': '3 mois'
  },
  {
    'id': '137555',
    'label': '6 mois'
  }
];

export const NURSING_HOME_2_OPTIONAL_STAY_TYPES: string[] = ['137557', '137556'];

export const STAY_REQUEST_NURSING_HOME1 = [
  {
    'id': '156527',
    'label': 'RSG',
    'stay_types': [137556],
    'disables_choice_2': true
  },
  {
    'id': '137583',
    'label': 'EMS Billens',
    'stay_types': [137557, 137556]
  },
  {
    'id': '137585',
    'label': 'EMS Siviriez',
    'stay_types': [137557, 137556, 137558]
  },
  {
    'id': '137584',
    'label': 'EMS Vuisternens',
    'stay_types': [137556, 137559]
  },
  {
    'id': '137551',
    'label': 'Billens',
    'stay_types': [137560]
  }
];
export const STAY_REQUEST_NURSING_HOME2 = [
  {
    'id': '137586',
    'label': 'EMS Billens',
    'stay_types': [137557, 137556]
  },
  {
    'id': '137588',
    'label': 'EMS Siviriez',
    'stay_types': [137557, 137556, 137558]
  },
  {
    'id': '137587',
    'label': 'EMS Vuisternens',
    'stay_types': [137556, 137559]
  },
  {
    'id': '137571',
    'label': 'Billens',
    'stay_types': [137560]
  }
];


export const THERAPEUTIC_REP_TITLES = [
  {
    'id': '137517',
    'label': 'Madame'
  },
  {
    'id': '137518',
    'label': 'Monsieur'
  }
];
